import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BookingTabFilters from 'components/BusinessLogic/Booking/BookingTabFilters';
import EditableSelect from 'components/UI/Input/EditableSelect';
import _ from 'lodash';
import moment from 'moment/moment';

function BookingTabs({ onFiltersUpdate, initialFilters })
{
    const currentStatus = [
        ['Pending', 'Booked'],
        ['Cancelled'],
        ['Postponed'],
        null,
        'past_reservations',
    ];

    const currentStatusSelect = [
        'Pending & Booked',
        'Cancelled',
        'Postponed',
        'All',
        'Past Reservations',
    ].map((prefix, index) => ({ label: prefix, value: index }));

    const getDefaultStatusIndex = (status) =>
    {
        const parsedStatus = _.isArray(status) ? status : status?.split(',');
        const currentIndex = currentStatus.findIndex((statusValue) => _.isEqual(statusValue, parsedStatus));

        return currentIndex !== -1 ? currentIndex : 0;
    };

    const getDefaultSortIndex = (sortBy) =>
    {
        const currentIndex = sortable.findIndex((sortableValue) => _.isEqual(sortableValue.value, sortBy));

        return currentIndex !== -1 ? currentIndex : 0;
    };

    const sortable = [
        'Creation Date',
        'Check In ',
        'Check Out ',
    ].map((prefix) => ({ label: prefix, value: prefix }));

    const initialValues = {
        checkinAfter: initialFilters.checkinAfter,
        checkinBefore: initialFilters.checkinBefore,
        checkoutBefore: initialFilters.checkoutBefore,
        bookingDateAfter: initialFilters.bookingDateAfter,
        bookingHotel: initialFilters.bookingHotel,
        sortBy: sortable[getDefaultSortIndex(initialFilters.sortBy)],
        sortByOrder: initialFilters.sortByOrder,
    };

    const [filters, setFilters] = useState({ ...initialValues });

    const [activeTab, setActiveTab] = useState(getDefaultStatusIndex(initialFilters.status));

    const openTab = (selectedTab) =>
    {
        const clearFilters = activeTab > 3 ? {
            checkinAfter: '',
            checkinBefore: '',
            checkoutBefore: '',
            sortBy: 'Creation Date',
            sortByOrder: 'desc',
        } : {};

        setActiveTab(selectedTab);
        onFiltersUpdate({
            ...clearFilters,
            status: currentStatus[selectedTab],
        });
    };

    const onFestiveTab = () =>
    {
        setActiveTab(5);

        const thisYear = moment(new Date()).format('YYYY');

        onFiltersUpdate(
            {
                ...initialFilters,
                ...{
                    status: '',
                    checkinAfter: moment(`${thisYear}-12-16`).toDate(),
                    checkinBefore: moment(`${parseInt(thisYear, 10) + 1}-01-08`).toDate(),
                    sortBy: { value: 'Check In ' },
                    sortByOrder: 'asc',
                },
            },
        );
    };

    const onPastReservationsTab = () =>
    {
        setActiveTab(4);

        onFiltersUpdate(
            {
                ...initialFilters,
                ...{
                    checkinAfter: '',
                    checkinBefore: '',
                    status: 'past_reservations',
                    checkoutBefore: moment(new Date()),
                    sortBy: { value: 'Check Out ' },
                    sortByOrder: 'desc',
                },
            },
        );
    };

    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-p-10 max-sm:tw-p-2">
            <div className="border-b tw-border-gray-200 tw-darkest:border-gray-700">
                <EditableSelect
                    editing
                    labelText={false}
                    className="tw-bg-transparent"
                    containerClassName="tw-flex-wrap tw-text-xl tw-font-medium tw-text-center tw-gap-1 tw-items-end tw-p-7 max-md:tw-flex tw-hidden tw-justify-center"
                    labelContainerClassName="tw-flex-auto tw-w-full"
                    inputProps={{
                        getOptionLabel: (option) => option?.label,
                        getOptionValue: (option) => option.value,
                        options: currentStatusSelect,
                        value: activeTab,
                    }}
                />
                <ul className="tw-flex tw-flex-wrap tw-text-sm tw-font-medium tw-text-center tw-gap-1 tw-items-end tw-h-20 max-md:tw-hidden">
                    <li className="" role="presentation">
                        <button
                            type="button"
                            onClick={() => openTab(0)}
                            className={`tw-inline-block tw-p-2 max-xl:tw-px-3 tw-px-6 tw-font-bold tw-border-transparent tw-transition-all hover:tw-bg-primary-default hover:tw-text-white ${activeTab !== 0
                                ? 'tw-bg-neutral-lighter tw-text-base dark:tw-bg-neutral-900'
                                : 'tw-bg-white tw-py-4 max-xl:tw-px-3 tw-px-6 tw-text-xl tw-text-primary-default dark:tw-bg-neutral-700'}`}
                        >
                            Booked
                        </button>
                    </li>
                    <li className="" role="presentation">
                        <button
                            type="button"
                            onClick={() => openTab(1)}
                            className={`tw-inline-block tw-p-2 max-xl:tw-px-3 tw-px-6  tw-font-bold tw-border-transparent tw-transition-all hover:tw-bg-primary-default hover:tw-text-white ${activeTab !== 1
                                ? 'tw-bg-neutral-lighter tw-text-base dark:tw-bg-neutral-900'
                                : 'tw-bg-white tw-py-4  max-xl:tw-px-3 tw-px-6 tw-text-xl tw-text-primary-default dark:tw-bg-neutral-700'}`}
                        >
                            Cancelled
                        </button>
                    </li>
                    <li className="" role="presentation">
                        <button
                            type="button"
                            onClick={() => openTab(2)}
                            className={`tw-inline-block tw-p-2 max-xl:tw-px-3 tw-px-6 tw-font-bold tw-border-transparent tw-transition-all hover:tw-bg-primary-default hover:tw-text-white ${activeTab !== 2
                                ? 'tw-bg-neutral-lighter tw-text-base dark:tw-bg-neutral-900'
                                : 'tw-bg-white tw-py-4 max-xl:tw-px-3 tw-px-6 tw-text-xl tw-text-primary-default dark:tw-bg-neutral-700'}`}
                        >
                            Postponed
                        </button>
                    </li>
                    <li className="" role="presentation">
                        <button
                            type="button"
                            onClick={() => openTab(3)}
                            className={`tw-inline-block tw-p-2 max-xl:tw-px-3 tw-px-6  tw-font-bold tw-border-transparent tw-transition-all hover:tw-bg-primary-default hover:tw-text-white ${activeTab !== 3
                                ? 'tw-bg-neutral-lighter tw-text-base dark:tw-bg-neutral-900'
                                : 'tw-bg-white tw-py-4 max-xl:tw-px-3 tw-px-6 tw-text-xl tw-text-primary-default dark:tw-bg-neutral-700'}`}
                        >
                            All
                        </button>
                    </li>
                    <li className="" role="presentation">
                        <button
                            type="button"
                            onClick={() => onPastReservationsTab()}
                            className={`tw-inline-block tw-p-2 max-xl:tw-px-3 tw-px-6  tw-font-bold tw-border-transparent tw-transition-all hover:tw-bg-primary-default hover:tw-text-white ${activeTab !== 4
                                ? 'tw-bg-neutral-lighter tw-text-base dark:tw-bg-neutral-900'
                                : 'tw-bg-white tw-py-4 max-xl:tw-px-3 tw-px-6 tw-text-xl tw-text-primary-default dark:tw-bg-neutral-700'}`}
                        >
                            Past Reservations
                        </button>
                    </li>
                    <li className="" role="presentation">
                        <button
                            type="button"
                            onClick={() => onFestiveTab()}
                            className={`tw-inline-block tw-p-2 max-xl:tw-px-3 tw-px-6  tw-font-bold tw-border-transparent tw-transition-all hover:tw-bg-primary-default hover:tw-text-white ${activeTab !== 5
                                ? 'tw-bg-neutral-lighter tw-text-base dark:tw-bg-neutral-900'
                                : 'tw-bg-white tw-py-4 max-xl:tw-px-3 tw-px-6 tw-text-xl tw-text-primary-default dark:tw-bg-neutral-700'}`}
                        >
                            Festive
                        </button>
                    </li>
                </ul>
            </div>
            <div id="myTabContent">
                <div className="tw-p-4 tw-bg-white tw-rounded-none dark:tw-bg-neutral-700">
                    {activeTab < 4 && (
                        <BookingTabFilters
                            onFiltersUpdate={onFiltersUpdate}
                            initialFilters={initialValues}
                            filters={filters}
                            setFilters={setFilters}
                            sortable={sortable}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

BookingTabs.propTypes = {
    onFiltersUpdate: PropTypes.func,
    initialFilters: PropTypes.any,
};

export default BookingTabs;
